import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface TooltipIconProps {
  tooltipText: string;
  placement?: 'top' | 'right' | 'bottom' | 'left';
}

const TooltipIcon: React.FC<TooltipIconProps> = ({ 
  tooltipText,
  placement = 'top' 
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={`tooltip-${Math.random()}`}>{tooltipText}</Tooltip>}
    >
      <span 
        className="ms-1 d-inline-block" 
        style={{ 
          cursor: 'help', 
          color: '#000000',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          border: '2px solid #030303ff',
          textAlign: 'center',
       
        }}
      >
        ?
      </span>
    </OverlayTrigger>
  );
};

export default TooltipIcon;
